var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var UserPermissionIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 40,
    glyphHeight: 60
  }), React.createElement("path", {
    d: "M32.313 24.3652V12.4695C32.313 5.58258 26.6782 0.156494 19.9999 0.156494C13.113 0.156494 7.68687 5.79128 7.68687 12.4695V24.3652C3.09557 27.913 0.173828 33.5478 0.173828 39.8087C0.173828 50.6608 9.14774 59.6348 19.9999 59.6348C30.8521 59.6348 39.826 50.6608 39.826 39.8087C39.826 33.7565 36.9043 28.1217 32.313 24.3652ZM12.4869 12.6782C12.4869 8.50432 15.826 5.16519 19.9999 5.16519C24.1738 5.16519 27.513 8.50432 27.513 12.6782V21.6521C25.2173 20.8174 22.713 20.1913 19.9999 20.1913C17.2869 20.1913 14.7825 20.8174 12.4869 21.6521C12.4869 21.4435 12.4869 12.6782 12.4869 12.6782ZM19.9999 54.8348C11.8608 54.8348 5.18252 48.1565 5.18252 40.0174C5.18252 31.8782 11.8608 25.2 19.9999 25.2C28.139 25.2 34.8173 31.8782 34.8173 40.0174C34.8173 48.1565 28.139 54.8348 19.9999 54.8348ZM25.0086 39.8087C25.0086 42.5217 22.713 44.8174 19.9999 44.8174C17.2869 44.8174 14.9912 42.5217 14.9912 39.8087C14.9912 37.0956 17.2869 34.8 19.9999 34.8C22.713 34.8 25.0086 37.0956 25.0086 39.8087Z"
  }));
};
export var UserPermissionIconGlyph = function (props) {
  return React.createElement(UserPermissionIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};